export var setCookie = function setCookie(_ref) {
  var name = _ref.name,
    value = _ref.value,
    _ref$expiryDays = _ref.expiryDays,
    expiryDays = _ref$expiryDays === void 0 ? 365 * 20 : _ref$expiryDays,
    domain = _ref.domain;
  var date = new Date();
  date.setTime(date.getTime() + expiryDays * 24 * 60 * 60 * 1000);
  var expiresStr = 'expires=' + date.toUTCString();
  var domainStr = domain ? ";domain=".concat(domain) : '';
  document.cookie = "".concat(name, "=").concat(value, ";").concat(expiresStr, ";path=/").concat(domainStr);
};
export var getCookie = function getCookie(cname) {
  var name = cname + '=';
  var cookieArray = document.cookie.split(';');
  for (var i = 0; i < cookieArray.length; i++) {
    var cookie = cookieArray[i];
    while (cookie.charAt(0) == ' ') {
      // eslint-disable-line
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) == 0) {
      // eslint-disable-line
      return cookie.substring(name.length, cookie.length);
    }
  }
  return '';
};